import React, { useState } from 'react';
import { Alert, Button, Input, Spin, Typography } from 'antd';
import { useApiRequest } from '../../hooks/useApiRequest';
import { useResource } from '../../hooks/useResource';
import { userMessageForError } from '../../utils/apiError';
import { countMatches, highlightSegments } from '../../utils/regulatoryAdminModel';

const { Text } = Typography;

const Body = ({ itemId }) => {
    const { request } = useApiRequest();
    const [term, setTerm] = useState('');
    const res = useResource(async () => (await request('GET', `/regulatory-content/${itemId}`)).data.item, [request, itemId]);
    if (res.status === 'loading' && !res.data) return <Spin />;
    if (res.status === 'error') return <Alert type="error" message={userMessageForError(res.error)} action={<Button onClick={res.reload}>Retry</Button>} />;
    const text = res.data?.text || '';
    const n = countMatches(text, term);
    return (
        <div data-testid="full-source">
            <Input aria-label="Search source text" placeholder="Search the source for a missed obligation" value={term} onChange={(e) => setTerm(e.target.value)} />
            <div><Text type="secondary" data-testid="source-match-count">{term.trim() ? `${n} match${n === 1 ? '' : 'es'}` : `${text.length} characters`}</Text></div>
            <pre style={{ maxHeight: 360, overflow: 'auto', whiteSpace: 'pre-wrap', background: 'var(--color-surface-sunken)', padding: 8 }}>
                {highlightSegments(text, term).map((s, i) => (s.hit ? <mark key={i}>{s.text}</mark> : <React.Fragment key={i}>{s.text}</React.Fragment>))}
            </pre>
        </div>
    );
};

/** Full official text for a review card, fetched only when the reviewer asks for it. */
const SourceTextViewer = ({ itemId }) => {
    const [open, setOpen] = useState(false);
    return (
        <div style={{ margin: '8px 0' }}>
            <Button onClick={() => setOpen((o) => !o)}>{open ? 'Hide full source text' : 'Show full source text'}</Button>
            {open && <Body itemId={itemId} />}
        </div>
    );
};

export default SourceTextViewer;
